import { NavLink } from 'react-router-dom';
import './vendorlist-navigation.scss';
import { QueryRequestHelper } from '@_common/query-request-helper';
import { useMemo } from 'react';
import { allParams } from '@_common/common-helper';

export default function VendorListNavigation(props: any) {
	const urlParamsFun = () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let request = QueryRequestHelper({ ...params });
		return request;
	  };
	
	  const mainQueryRequest = useMemo(() => urlParamsFun(), [
		window.location.href,
	  ]);
	return (
		<div className="vendor-list-navigation">
			<section className="inner-page-navigation-with-back-cta-buttons position-relative w-100">
				<div className="container-fluid d-flex justify-content-between align-items-center">
					<div className="d-flex">
						{/* <NavLink to={`/configuration/vendors/detail/${props.parentId}?${mainQueryRequest}`} className=""> */}

						<NavLink to={`/configuration/vendors?${allParams()}`} className="">
							<img
								src="/images/back-link.svg"
								className="img-fluid"
								height={24}
								width={24}
							/>
						</NavLink>
						<div className="inner-page-navigation-with-back-cta-button__header">
							<h4 className="inner-page-navigation-with-back-cta-button__header-title">
								Add to Vendors
							</h4>
						</div>
					</div>
					{!props.id ? (
						<ul className="inner-page-navigation-with-back-cta-buttons__navigation d-inline-flex position-absolute">
							<li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
								<NavLink
									to={`/configuration/vendors/detail-info/profile?${mainQueryRequest}`}
									className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
								>
									Profile
								</NavLink>
							</li>
						</ul>
					) : (
						<ul className="inner-page-navigation-with-back-cta-buttons__navigation d-inline-flex position-absolute">
							<li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
								<NavLink
									to={`/configuration/vendors/detail-info/profile/${props.parentId}/${props.id}?${mainQueryRequest}`}
									className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
								>
									Profile
								</NavLink>
							</li>
							<li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
								<NavLink
									to={`/configuration/vendors/detail-info/users/${props.parentId}/${props.id}?${mainQueryRequest}`}
									className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
								>
									Users
								</NavLink>
							</li>
							<li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
								<NavLink
									to={`/configuration/vendors/detail-info/map-to-locations/${props.parentId}/${props.id}?${mainQueryRequest}`}
									className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
								>
									Map to Sites
								</NavLink>
							</li>
							<li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
								<NavLink
									to={`/configuration/vendors/detail-info/headcount/${props.parentId}/${props.id}?${mainQueryRequest}`}
									className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
								>
									Headcount
								</NavLink>
							</li>
							<li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
								<NavLink
									to={`/configuration/vendors/detail-info/email/${props.parentId}/${props.id}?${mainQueryRequest}`}
									className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
								>
									Email Mapping
								</NavLink>
							</li>
						</ul>
					)}
					<div>
						{/* <button className="ascent-button ascent-button--header-buttons ascent-button--secondary mx-3">
								Edit
							</button> */}
						<button className="ascent-button ascent-button--visibility ascent-button--header-buttons ascent-button--primary">
							Save
						</button>
					</div>
				</div>
			</section>
		</div>
	);
}
